import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import AddActivityImageDialog from '@dialogs/add-activity-image-dialog'
import EditActivityImageDialog from '@dialogs/edit-activity-image-dialog'
import 'antd/dist/antd.css'
import { API } from '@const'
import { Select, MenuItem, FormControl, InputLabel, Grid, Switch, TextField, Button, Icon } from '@material-ui/core'
import { PfSubPfSelect } from '@select'
import { Search, Edit, Delete } from '@material-ui/icons'
import { SingleConfirmMsgDialog } from '@msg'
import { addToast } from '../../utils/toast'
import moment from 'moment'
import MaterialTable from 'material-table'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
const COMPONENT_GROUP = 'activity_image_manage'

class ActivityImageManagePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ActivityImageManagePage')
        }
    }
    state = {
        isTableLoading: false,
        imgType: 'bannerImg',
        isDesignatedPlatform: 'isDesignatedPlatform',
        searchMode: 'nameSearch',
        searchName: '',
        searchStatus: 'active',
        pfSubPfId: 'all',
        rankinputs: {},
        sort: false,
        data: [],
        pf_id: 'acthb',
        subPfSortList: []
    }

    actions = []

    columns = [
        {
            title: utils.t('createdAt', 'ActivityImageManagePage'),
            field: 'createdAt',
            render: (rowData) => {
                return <div>{moment(rowData.created_at).format('YYYY-MM-DD')}</div>
            },
        },
        {
            title: utils.t('name', 'ActivityImageManagePage'),
            field: 'name',
            render: (rowData) => {
                return <div>{rowData.name}</div>
            },
        },
        {
            title: utils.t('currency', 'ActivityImageManagePage'),
            field: 'currency',
            render: (rowData) => {
                return rowData.pf_id ? <div>{utils.getPfCurrency(rowData.pf_id)}</div> : <></>
            },
        },
        {
            title: utils.t('pfSubPfList', 'ActivityImageManagePage'),
            field: 'pfSubPfList',
            render: (rowData) => {
                return rowData.pf_sub_pf_list ? (
                    <div>
                        <Button
                            color="primary"
                            variant="contained"
                            className={this.props.classes.button}
                            onClick={() => {
                                this.singleConfirmDialog.OpenDialog({
                                    type: this.t('pfSubPfList'),
                                    msg: rowData.pf_sub_pf_list.map((pfSubPfID) => utils.GeneratePfSubPfName(pfSubPfID)).join('\n'),
                                })
                            }}>
                            {this.t('view')}
                        </Button>
                    </div>
                ) : (
                    <></>
                )
            },
        },
        {
            title: utils.t('startAt', 'ActivityImageManagePage'),
            field: 'startAt',
            render: (rowData) => {
                return <div>{ moment.unix(rowData.start_at).utcOffset(-4).format('YYYY-MM-DD HH:mm') }</div>
            },
        },
        {
            title: utils.t('endAt', 'ActivityImageManagePage'),
            field: 'endAt',
            render: (rowData) => {
                return <div>{ moment.unix(rowData.end_at).utcOffset(-4).format('YYYY-MM-DD HH:mm') }</div>
            },
        },
        {
            title: utils.t('sort', 'ActivityImageManagePage'),
            field: 'sort',
            render: (rowData) => {
                const reverseRanks = this.state.data.map((item) => item.rank).reverse()
                const enterRank = this.state.rankinputs[rowData.id]
                const isEdit = enterRank && String(JSON.parse(JSON.stringify(reverseRanks)).reverse()[rowData.rank - 1]) !== String(enterRank)

                const confirm = () => {
                    if (enterRank) {
                        const newRank = Number(enterRank)
                        if (newRank === 0) return
                        if (newRank > this.state.data.length) {
                            addToast(utils.t('sortQuantityOverload', 'GameRecommendDialog'), 'error')
                            return
                        }
                        this.sortRank(rowData.id, newRank)
                    }
                }

                return this.state.sort ? (
                    <div style={{ display: 'flex' }}>
                        <input
                            onKeyDown={(event) => {
                                if (event.keyCode === 13) {
                                    if (!isEdit) return
                                    confirm()
                                }
                            }}
                            placeholder={JSON.parse(JSON.stringify(reverseRanks)).reverse()[rowData.rank - 1]}
                            value={enterRank || ''}
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '')
                                if (String(value).charAt(0) === '0') return
                                this.setState({
                                    rankinputs: {
                                        ...this.state.rankinputs,
                                        [rowData.id]: value,
                                    },
                                })
                            }}
                            className={this.props.classes.sortInput}
                        />
                        {isEdit && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    confirm()
                                }}
                                className={this.props.classes.sortButton}>
                                {this.t('confirm')}
                            </Button>
                        )}
                    </div>
                ) : (
                    <></>
                )
            },
            cellStyle: {
                width: '210px',
            },
        },
        {
            title: utils.t('isActive', 'ActivityImageManagePage'),
            field: 'isActive',
            render: (rowData) => {
                return (
                    <div>
                        <Switch
                            checked={rowData.is_active}
                            color="primary"
                            onChange={() => {
                                this.switchBanner(rowData.id)
                            }}
                        />
                    </div>
                )
            },
        },
    ]

    componentDidMount() {
        this.checkPermissions()
        this.queryData()
    }

    queryData() {
        this.setState({ isTableLoading: true })
        utils.apiRequest(
            'get',
            API.ACTIVITY_IMAGES,
            {
                type: this.state.imgType === 'bannerImg' ? 1 : 2,
            },
            (data) => {
                this.setState({
                    data: data,
                    assignData: data,
                    isTableLoading: false,
                    subPfSortList: this.pfSubPfSelect.state.subPfSortList
                })
                if (this.state.sort) this.setState({ sort: false }, this.searchQuery())
            },
            (_err) => {
                this.setState({ data: [] })
            },
            true
        )
    }

    switchBanner(id) {
        utils.apiRequest(
            'patch',
            `${API.ACTIVITY_IMAGES}/${id}/switch`,
            {},
            (_data) => {
                this.queryData()
            },
            (_err) => {
                this.queryData()
            },
            false
        )
    }

    sortRank(id, newRank) {
        let currentObject
        const cloneData = JSON.parse(JSON.stringify(this.state.data)).map((item, index) => {
            item.rank = index + 1
            if (item.id === id) currentObject = item
            return item
        })
        const currentRank = currentObject.rank
        if (currentObject) {
            if (currentRank === newRank || newRank === 0) return
            cloneData.forEach((item) => {
                const isCurrentItem = item.id === id // 是否為要變更排名的 item
                if (isCurrentItem) {
                    item.rank = newRank
                    return
                }
                if (item.rank > currentRank && item.rank <= newRank) {
                    item.rank--
                }
                if (item.rank < currentRank && item.rank >= newRank) {
                    item.rank++
                }
            })
            cloneData.sort((a, b) => a.rank - b.rank)
            this.setState({
                data: cloneData,
                rankinputs: {},
            })
        }
    }

    updateData() {
        const ranks = this.state.data.map((item) => item.id).reverse()
        utils.apiRequest(
            'post',
            API.ACTIVITY_IMAGES_RANKS,
            { type: 1, ranks },
            (_data) => {
                this.queryData()
            },
            (_err) => { },
            false
        )
    }

    deleteData(id) {
        this.confirmDialog.OpenDialog({
            type: 'warn',
            msg: `${this.t('confirmDeleteMsg')}`,
            confirm: () => {
                utils.apiRequest(
                    'delete',
                    `${API.ACTIVITY_IMAGES}/${id}`,
                    {},
                    (_data) => {
                        this.queryData()
                        this.confirmDialog.closeDialog()
                    },
                    (_err) => {
                        this.queryData()
                    },
                    false
                )
            },
        })
    }

    checkPermissions() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: '',
                render: (rowData) => {
                    return (
                        <div
                            onClick={() => {
                                this.EditActivityImageDialog.OpenDialog({
                                    title: utils.t('editActivityImage', 'ActivityImageDialog'),
                                    pf_id:
                                        this.pfSubPfSelect.state.pfId === 'all' ? this.pfSubPfSelect.state.pfList[0] : this.pfSubPfSelect.state.pfId,
                                    rowData,
                                })
                            }}
                            className={this.props.classes.actionBtn}>
                            <Edit color="primary" />
                            {this.t('edit')}
                        </div>
                    )
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.columns.push({
                field: '',
                render: (rowData) => {
                    return (
                        <div
                            onClick={() => {
                                this.deleteData(rowData.id)
                            }}
                            className={this.props.classes.actionBtn}>
                            <Delete color="primary" />
                            {this.t('delete')}
                        </div>
                    )
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                icon: 'add',
                text: 'add',
                tooltip: 'Save User',
                isFreeAction: true,
                onClick: () => {
                    this.AddActivityImageDialog.OpenDialog({
                        title: utils.t('addActivityImage', 'ActivityImageDialog'),
                        pf_id: this.pfSubPfSelect.state.pfId === 'all' ? this.pfSubPfSelect.state.pfList[0] : this.pfSubPfSelect.state.pfId,
                    })
                },
            })
        }
    }

    searchQuery() {
        const data =
            this.pfSubPfSelect.state.pfId === 'all'
                ? JSON.parse(JSON.stringify(this.state.assignData))
                : JSON.parse(JSON.stringify(this.state.assignData)).filter((item) => item.pf_id === this.pfSubPfSelect.state.pfId)
        switch (this.state.searchMode) {
            case 'nameSearch':
                this.setState({
                    data: data.filter((item) => item.name.includes(this.state.searchName)),
                })
                break
            case 'platformSearch':
                this.setState({
                    data: this.state.pfSubPfId === 'all' ? data : data.filter((item) => item.pf_sub_pf_list?.includes(this.state.pfSubPfId)),
                })
                break
            case 'statusSearch':
                this.setState({
                    data: data.filter((item) => item.is_active === (this.state.searchStatus === 'active')),
                })
                break
            default:
                this.setState({ data: [] })
                break
        }
    }

    render() {
        const isNameSearch = this.state.searchMode === 'nameSearch'
        const isPlatformSearch = this.state.searchMode === 'platformSearch'
        const isStatusSearch = this.state.searchMode === 'statusSearch'
        return (
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel>{this.t('imgType')}</InputLabel>
                            <Select
                                disabled={this.state.sort}
                                value={this.state.imgType}
                                onChange={(event) => {
                                    this.setState(
                                        {
                                            imgType: event.target.value,
                                        },
                                        () => {
                                            this.queryData()
                                        }
                                    )
                                }}>
                                {['bannerImg', 'iconImg'].map((item) => (
                                    <MenuItem value={item} key={item}>
                                        {this.t(item)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <PfSubPfSelect
                        onRef={(ref) => (this.pfSubPfSelect = ref)}
                        options={{
                            pfChangeCallback: () => {
                                this.setState({ pf_id: this.pfSubPfSelect.state.pfId, pfSubPfId: 'all' }, () => {
                                    this.setState({
                                        subPfSortList: this.pfSubPfSelect.state.subPfSortList,
                                    })
                                })
                            },
                            hideAutocomplete: true,
                            hideAllPlatform: false,
                            disabled: this.state.sort,
                        }}
                    />
                    <Grid item xs={2}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel>{this.t('searchMethod')}</InputLabel>
                            <Select
                                disabled={this.state.sort}
                                value={this.state.searchMode}
                                onChange={(event) => {
                                    this.setState({
                                        searchMode: event.target.value,
                                    })
                                }}>
                                {['nameSearch', 'platformSearch', 'statusSearch'].map((item) => (
                                    <MenuItem value={item} key={item}>
                                        {this.t(item)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {isNameSearch && (
                        <Grid item xs={2}>
                            <div className={this.props.classes.alignCenter}>
                                <TextField
                                    disabled={this.state.sort}
                                    className={this.props.classes.searchTextField}
                                    value={this.state.searchName}
                                    onChange={(event) => {
                                        this.setState({
                                            searchName: event.target.value,
                                        })
                                    }}
                                    variant="standard"
                                    placeholder={this.t('enterSearchKeywords')}
                                    type="text"
                                />
                                <div onClick={() => this.setState({ searchName: '' })} className={this.props.classes.clearSearch}>
                                    X
                                </div>
                            </div>
                        </Grid>
                    )}
                    {isPlatformSearch && (
                        <Grid xs={2} item className={this.props.classes.alignCenter}>
                            <FormControl className={this.props.classes.formControl}>
                                <InputLabel>{this.t('pfSubPf')}</InputLabel>
                                <Select
                                    disabled={this.state.sort}
                                    value={this.state.pfSubPfId}
                                    onChange={(event) => {
                                        this.setState({
                                            pfSubPfId: event.target.value,
                                        })
                                    }}>
                                    {
                                        <MenuItem value={'all'} key={'all'}>
                                            {utils.t('allSubPlatform', 'PfSubPfSelect')}
                                        </MenuItem>
                                    }
                                    {this.state.subPfSortList.map((item) => (
                                        <MenuItem value={item.pf_sub_pf_id} key={item.name}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {isStatusSearch && (
                        <Grid item xs={2} className={this.props.classes.alignCenter}>
                            <FormControl className={this.props.classes.formControl}>
                                <InputLabel>{this.t('isActive')}</InputLabel>
                                <Select
                                    disabled={this.state.sort}
                                    value={this.state.searchStatus}
                                    onChange={(event) => {
                                        this.setState({
                                            searchStatus: event.target.value,
                                        })
                                    }}>
                                    {['active', 'close'].map((item) => (
                                        <MenuItem value={item} key={item}>
                                            {this.t(item)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid item className={this.props.classes.alignCenter}>
                        <Button
                            disabled={this.state.sort}
                            className={this.props.classes.searchBtn}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                this.searchQuery()
                            }}>
                            <Search className={this.props.classes.rightIcon} />
                            {this.t('search', {})}
                        </Button>
                        {this.state.sort ? (
                            <>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.updateData()
                                    }}
                                    className={this.props.classes.searchBtn}>
                                    {this.t('send')}
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        this.setState({
                                            sort: false,
                                            data: this.state.assignData,
                                        })
                                    }}>
                                    {this.t('cancel')}
                                </Button>
                            </>
                        ) : (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.setState({ data: this.state.assignData }, () => { // 第一層 開啟排序先強制顯示成全部資料
                                        this.setState({ searchMode: 'statusSearch', searchStatus: 'active' }, () => { // 第二層 顯示全部資料且狀態啟用的
                                            this.pfSubPfSelect.setState({ pfId: 'all' }, () => { // 第三層 將站台選擇為 'all'
                                                this.searchQuery()
                                                this.setState({ // 第四層 開啟排序
                                                    sort: true
                                                })
                                            })
                                        })
                                    })
                                }}>
                                {this.state.sort ? this.t('closeEditRank') : this.t('editRank')}
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <MaterialTable
                            isLoading={this.state.isTableLoading}
                            title={''}
                            actions={this.actions}
                            components={{
                                Action: (props) => (
                                    <Button onClick={(event) => props.action.onClick(event, props.data)} color="primary">
                                        <Icon>{props.action.icon}</Icon>
                                        {this.t(props.action.text)}
                                    </Button>
                                ),
                            }}
                            ownerName="ActivityImageManagePage"
                            data={this.state.data}
                            columns={this.columns}
                            options={{
                                exportButton: false,
                                tableLayout: 'fixed',
                                pageSize: 10,
                                pageSizeOptions: [10, 50, 100],
                                search: false,
                                sorting: false,
                            }}
                            onRef={(ref) => (this.table = ref)}
                        />
                        <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                    </Grid>
                </Grid>
                <AddActivityImageDialog
                    confirmCallback={() => {
                        this.queryData()
                    }}
                    onRef={(ref) => {
                        this.AddActivityImageDialog = ref
                    }}
                />
                <EditActivityImageDialog
                    confirmCallback={() => {
                        this.queryData()
                    }}
                    onRef={(ref) => {
                        this.EditActivityImageDialog = ref
                    }}
                />
                <SingleConfirmMsgDialog onRef={(ref) => (this.singleConfirmDialog = ref)} />
            </div>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            width: '100%',
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
            position: 'relative',
        },
        actionBtn: {
            cursor: 'pointer',
        },
        clearSearch: {
            color: '#BFBFBF',
            cursor: 'pointer',
            position: 'absolute',
            right: '0',
            paddingTop: '15px',
        },
        searchTextField: {
            paddingTop: '15px',
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        searchBtn: {
            marginRight: '20px',
        },
        sortInput: {
            width: '80px',
            height: '36.5px',
            marginRight: '10px',
        },
    }
}

ActivityImageManagePage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(ActivityImageManagePage)
